import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import propTypes from 'prop-types';
import { FaTrash } from 'react-icons/fa';
import FileSelect from '../../../components/FileSelect';

export default function AssemblyDownloads({ files, name }) {
  const { setFieldValue } = useFormikContext();

  const handleChange = e => setFieldValue(name, [...files, ...e.target.files]);

  return (
    <FieldArray
      name={name}
      render={({ remove }) => (
        <>
          <ul className="list-group">
            {files.map((file, index) => (
              <li
                className="list-group-item d-flex justify-content-between align-items-center"
                key={`${name}-${file._id || index}`}
              >
                <span>{file.name}</span>
                <button className="btn btn-icon btn-clear m-0 p-0" type="button" onClick={() => remove(index)}>
                  <FaTrash />
                </button>
              </li>
            ))}
          </ul>
          <FileSelect onChange={handleChange} name={name} id={name} multiple />
        </>
      )}
    />
  );
}

AssemblyDownloads.propTypes = {
  name: propTypes.string.isRequired,
  files: propTypes.array,
};

AssemblyDownloads.defaultProps = {
  files: [],
};
